import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconSettingsFn = /* @__PURE__ */ createRecipe('radio-icon-settings', {}, [])

const radioOnlyIconSettingsVariantMap = {}

const radioOnlyIconSettingsVariantKeys = Object.keys(radioOnlyIconSettingsVariantMap)

export const radioOnlyIconSettings = /* @__PURE__ */ Object.assign(memo(radioOnlyIconSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconSettings',
  __getCompoundVariantCss__: radioOnlyIconSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconSettingsVariantKeys,
  variantMap: radioOnlyIconSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconSettingsVariantKeys)
  },
  getVariantProps: radioOnlyIconSettingsFn.getVariantProps,
})